import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { batch, useDispatch } from "react-redux";
import { TOGGLE_NEED_INGREDIENT } from "../constants/reducerEvents";

const invalid = (q) => {
  return q === null || q === undefined;
};

export default function CombinedIngredient({
  ingredient,
  onClick = null,
  isChecked = undefined,
}) {
  const dispatch = useDispatch();
  const overallChecked =
    isChecked === undefined ? !ingredient.checked.some((t) => !t) : isChecked;
  const displayQuantity = ingredient.quantities
    .map((q, i) => {
      if (invalid(q) || invalid(ingredient.measurements[i])) {
        if (ingredient.multipliers[i] === 1) {
          return `${ingredient.originals[i]}`;
        }
        return `${ingredient.multipliers[i]}x ${ingredient.originals[i]}`;
      } else {
        return `${q * ingredient.multipliers[i]} ${ingredient.measurements[i]}`;
      }
    })
    .join(", ");
  const clicked = () => {
    // setChecked(!ingredient.checked);
    if (onClick != null) {
      onClick(ingredient);
      return;
    }
    batch(() => {
      ingredient.sources.forEach((s, i) => {
        if (overallChecked === ingredient.checked[i]) {
          dispatch({
            type: TOGGLE_NEED_INGREDIENT,
            payload: { url: s.url, index: s.index },
          });
        }
      });
    });
  };
  return (
    <div style={{ display: "flex", paddingLeft: "10px" }}>
      <div>
        <FormControlLabel
          control={<Checkbox checked={overallChecked} onChange={clicked} />}
          label={
            ingredient.label
              ? `${ingredient.label} (${displayQuantity})`
              : displayQuantity
          }
        />
      </div>
      {/* <div>{`(${displayQuantity})`}</div> */}
      {/* <div style={{ display: "flex" }}>
        <div>{"("}</div>
        {ingredient.quantities.map((q, i) => {
          if (invalid(q) || invalid(ingredient.measurements[i])) {
            return <div>{`${ingredient.originals[i]}, `}</div>;
          } else {
            return (
              <div>{`${q * ingredient.multipliers[i]} ${
                ingredient.measurements[i]
              }, `}</div>
            );
          }
        })}
        <div>{")"}</div>
      </div> */}
      {/* {JSON.stringify(ingredient)} */}
    </div>
  );
}
// {"checked":false,"originals":["1/4 teaspoon garlic powder (or 1/3 teaspoon minced garlic)"],"sources":[{"url":"https://cafedelites.com/breakfast-egg-muffins-3-ways/"}],"label":"Garlic Powder","quantities":[null],"measurements":["Teaspoon"]}
